import { ApplicationRef, ComponentRef, createComponent, EmbeddedViewRef, EnvironmentInjector, Service, inject } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SnackbarComponent } from '../../components/snackbar/snackbar.component';
import { StatusLabel } from '../../models/common/status-label.model';

@Service()
export class UtilsService {

  private _navbarTitleSubject = new BehaviorSubject<{ title: string, translateProperty: {}; }>(null);
  private _statusLableSubject = new BehaviorSubject<StatusLabel>(null);
  private _mySnackbarSubject = new BehaviorSubject<ComponentRef<SnackbarComponent>>(null);

  private applicationRef = inject(ApplicationRef);
  private environmentInjector = inject(EnvironmentInjector);

  navbarTitle(): Observable<{ title: string, translateProperty: {}; }> {
    return this._navbarTitleSubject.asObservable();
  }

  setNavbarTitle(title: string, translateProperty?: {}) {
    this._navbarTitleSubject.next({ title, translateProperty });
  }

  getStatusLabel(): Observable<StatusLabel> {
    return this._statusLableSubject.asObservable();
  }

  setStatusLabel(lastUpdateDate?: string, createdDate?: string, lastUpdateUserId?: number, createUserId?: number) {
    if(lastUpdateDate || lastUpdateUserId || createdDate || createUserId){
      const statusLabel: StatusLabel = {
        lastUpdateDate,
        createdDate,
        lastUpdateUserId,
        createUserId
      };
      this._statusLableSubject.next(statusLabel);
    }
  }

  public showSnackbar(message: string, milliseconds: number = null, color: 'success' | 'warning' | 'danger' | 'info' | 'primary' | 'secondary' = null, title: string = null, manualClose: boolean = false, messageExtension?: {}) {
    if (this._mySnackbarSubject.value) this.closeSnackbar(this._mySnackbarSubject.value);
    // createComponent sostituisce ComponentFactoryResolver, rimosso da @angular/core in v22
    const componentRef = createComponent(SnackbarComponent, { environmentInjector: this.environmentInjector });
    componentRef.instance.messageExtension = messageExtension;
    componentRef.instance.message = message;
    componentRef.instance.manualClose = manualClose;
    if (color) componentRef.instance.color = color;
    if (title) componentRef.instance.title = title;
    this.applicationRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
    componentRef.instance.show = true;
    componentRef.instance.close.subscribe(() => this.closeSnackbar(componentRef));
    this._mySnackbarSubject.next(componentRef);
    if (!milliseconds) milliseconds = manualClose ? 40000 : 3500;
    setTimeout(() => {
      this.closeSnackbar(componentRef);
    }, milliseconds);
  }

  private closeSnackbar(componentRef: ComponentRef<SnackbarComponent>) {
    componentRef.instance.show = false;
    setTimeout(() => this._mySnackbarSubject.next(null));
    setTimeout(() => {
      this.applicationRef.detachView(componentRef.hostView);
      componentRef.destroy();
    }, 500);
  }
}
